import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EXTERNAL_PATH } from '@common/types/route-path.enum';
import { LegalPageState } from '@common/types/types';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { I18nService } from '../../../services/i18n.service';

enum AppName {
	ClausiusBT = 'Clausius BT',
	Oeg = 'Oeg heat@home',
	SilverTec = 'Heat@Home direct',
}

@Component({
	selector: 'app-legal-page',
	templateUrl: './legal-page.component.html',
	styleUrls: ['./legal-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalPageComponent implements OnInit, AfterViewInit, OnDestroy {
	EXTERNAL_PATH = EXTERNAL_PATH;
	LegalPageState = LegalPageState;
	legalPageState$ = new BehaviorSubject<LegalPageState>(LegalPageState.Terms);
	unsubscribe$: Subscription | null = null;

	private chapter: string;

	displayValues = {
		appName: '',
	};

	constructor(
		private route: ActivatedRoute,
		private i18nService: I18nService
	) {}

	ngOnInit(): void {
		this.unsubscribe$ = this.route.queryParams
			.pipe(
				tap(({ page, chapter }) => {
					switch (page) {
						case 'terms':
							this.legalPageState$.next(LegalPageState.Terms);
							break;
						case 'terms_partners':
							this.legalPageState$.next(LegalPageState.TermsPartners);
							break;
						case 'privacy':
							this.legalPageState$.next(LegalPageState.Privacy);
							break;
						case 'clausiusbt':
							this.displayValues.appName = AppName.ClausiusBT;
							this.legalPageState$.next(LegalPageState.ClausiusBT);
							break;
						case 'oegHeatHome':
							this.displayValues.appName = AppName.Oeg;
							this.legalPageState$.next(LegalPageState.Oeg);
							break;
						case 'heatHomeDirect':
							this.displayValues.appName = AppName.SilverTec;
							this.legalPageState$.next(LegalPageState.Silvertec);
							break;
					}

					if (chapter) {
						this.chapter = chapter;
					}
				})
			)
			.subscribe();
	}

	ngAfterViewInit() {
		if (this.chapter) {
			const chapterLabelEl = Array.from(
				document.querySelectorAll('div.label')
			).find((el) => el.textContent.startsWith(this.chapter));
			if (chapterLabelEl) {
				chapterLabelEl.scrollIntoView({
					behavior: 'smooth',
				});
			}
		}
	}

	scrollTo(identifier: string) {
		const el = document.getElementById(identifier);
		if (el) {
			el.scrollIntoView({
				behavior: 'smooth',
			});
		}
	}

	get languageName() {
		return this.i18nService.languageName;
	}

	ngOnDestroy(): void {
		if (this.unsubscribe$) {
			this.unsubscribe$.unsubscribe();
		}
	}
}
